module.exports = __webpack_public_path__ + "img/success-case.a28bc106.png";